export const ListQueryKey = 'fruitRecords';
export const DetailQueryKey = 'fruitRecord';

export const Urls = {
  selectUrl: '/fruitRecord/list',
  updateUrl: '/fruitRecord/update',
  deleteUrl: '/fruitRecord/delete',
  createUrl: '/fruitRecord/create',
  detailUrl: '/fruitRecord/detail',
};
